import { ensureModeLayout } from "../core/surface-host.js";

export function ensureAdminContentLayout(layoutRoot, mode, contentHTML) {
  return ensureModeLayout(layoutRoot, "data-admin-layout-mode", mode, `
    <main class="content content--admin-route">
      ${contentHTML}
    </main>
  `);
}
